<template>
  <div class="volunteers">
    <ag-table :data-source-api="getAllVolunteers" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitExportToExcel="onExportToExcel">
      <template #action>
        <button @click="onExportTasksVolunteers()" class="export-tasksvolunteers">
          <feather-icon icon="DownloadIcon" class="mr-2 button_icon" />
          <span>تصدير مهام المتطوعين</span>
        </button>
        <button @click="onOpenUploadPopup()" class="upload-volunteers-zip">
          <feather-icon icon="UploadIcon" class="mr-2 button_icon" />
          <span>رفع صور المتطوعين</span>
        </button>
      </template>
    </ag-table>

    <tm-popup :submit="onUploadZipFile" title="رفع صور المتطوعين" ref="uploadPopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-file-select
            v-model="volunteersImagesFile"
            name="ملف صور المتطوعين"
            placeholder="اختر ملف صور المتطوعين (zip)"
            accept=".zip"
            :multiple="false"
            validation-rules="required"
          />
        </div>
        <div v-if="uploadState !== 'idle'" class="vx-col w-full mb-2 upload-status">
          <div v-if="uploadState === 'uploading'">
            <p class="upload-status__label">جاري رفع الملف... {{ uploadProgress }}%</p>
            <div class="upload-status__bar-track">
              <div class="upload-status__bar-fill" :style="{ width: uploadProgress + '%' }"></div>
            </div>
          </div>
          <p v-else-if="uploadState === 'processing'" class="upload-status__label upload-status__label--processing">
            ⏳ جاري معالجة الصور...
          </p>
          <p v-else-if="uploadState === 'completed'" class="upload-status__label upload-status__label--success">
            ✅ تم رفع الصور ومعالجتها بنجاح
          </p>
          <p v-else-if="uploadState === 'failed'" class="upload-status__label upload-status__label--error">
            ❌ فشلت عملية المعالجة، يرجى المحاولة مجدداً
          </p>
        </div>
      </div>
    </tm-popup>

    <!-- <tm-popup :submit="onVolunteerPopupSubmit" :title="volunteerPopupTitle" ref="volunteerPopup">
      <div class="vx-row justify-start">
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="الاسم" placeholder="الاسم" type="text" validation-rules="required"
            v-model="volunteer.name" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="رقم الموبايل" placeholder="رقم الموبايل" type="text"
            :validation-rules="{ required: true, digits: 9, regex: /^9\d{8}$/ }" v-model="volunteer.phoneNumber" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="رقم البطاقة" placeholder="رقم البطاقة" type="text" validation-rules="required"
            v-model="volunteer.cardNumber" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="كود اليسير" placeholder="كود اليسير" type="text" validation-rules="required"
            v-model="volunteer.uniqueIdentifier" />
        </div>
      </div>
    </tm-popup> -->
  </div>
</template>

<script>
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgTable from '../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import TmFileSelect from "../../shared/shared-components/TmFileSelect.vue";
import TmPopup from "../../shared/shared-components/TmPopup.vue";
import VolunteerStatusBadge from "../components/VolunteerStatusBadge.vue";
import VolunteerStatusSwitch from "../components/VolunteerStatusSwitch.vue";
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';


const volunteerRepo = RepositoryFactory.get('volunteerRepository');
export default {
  name: "VolunteersManagement",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
    TmPopup,
    TmFileSelect,
    // eslint-disable-next-line vue/no-unused-components
    VolunteerStatusBadge,
    // eslint-disable-next-line vue/no-unused-components
    VolunteerStatusSwitch,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      // volunteerPopupTitle: '',
      volunteersImagesFile: null,
      uploadProgress: 0,
      uploadState: 'idle', // idle | uploading | processing | completed | failed
      pollInterval: null,
      // volunteer: {
      //   name: null,
      //   phoneNumber: null,
      //   cardNumber: null,
      //   uniqueIdentifier: null,
      // },
      permissions: {
        // add: 'volunteers_management',
        // edit: 'volunteers_management',
        // delete: 'volunteers_management',
      }
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      const activeStatusLabels = { true: 'نشط', false: 'غير نشط' };
      return [
        {
          headerName: 'معرف المتطوع',
          field: 'id',
          // filter: 'agNumberColumnFilter',
          sortable: false,
          width: 200,
        },
        {
          headerName: 'الاسم',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'كود اليسير',
          field: 'uniqueIdentifier',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'رقم البطاقة',
          field: 'cardNumber',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'رقم الموبايل',
          field: 'phoneNumber',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'المجموعة',
          field: 'volunteerInfo.groupName',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'حالة المتطوع',
          field: 'volunteerInfo.cardStatus',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'الحالة',
          field: 'isActive',
          cellRendererFramework: VolunteerStatusBadge,
          sortable: true,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(activeStatusLabels),
            valueFormatter: (params) => activeStatusLabels[params.value] || params.value,
          },
          width: 150,
        },
        {
          headerName: 'هل كلمة المرور مؤقتة',
          field: 'isTemporaryPassword',
          // filter: 'agTextColumnFilter',
          valueGetter:
            function getObject(params) {
              return params.data.isTemporaryPassword ? 'نعم' : 'لا';
            },
          width: 210,
          sortable: false,
        },
        {
          headerName: 'تغيير الحالة',
          field: 'uniqueIdentifier',
          cellRendererFramework: VolunteerStatusSwitch,
          cellRendererParams: {
            switchAction: function (volunteer) {
              self.onToggleVolunteerStatus(volunteer);
            }
          },
          width: 160,
        },
        {
          headerName: 'الإجراءات',
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          cellRendererParams: {
            deleteRecord: function (id) {
              self.onDeleteVolunteer(id);
            },
            // editRecord: function (volunteer) {
            //   self.onUpdateVolunteer(volunteer);
            // },
            viewRecordDetails: function (volunteer) {
              self.$router.push({ path: `/volunteers/${volunteer.id}/actions` });
            },
            changePassword: function (volunteer) {
              self.onResetVolunteerPassword(volunteer);
            },
            actions: ['delete', 'change-password', 'view'],
            permissions: self.permissions
          },
        }
      ];
    },
    async onExportTasksVolunteers() {
      await volunteerRepo.exportTasksVolunteers();
    },
    async onExportToExcel() {
      await volunteerRepo.exportVolunteers();
    },
    async onDeleteVolunteer(volunteerId) {
      await volunteerRepo.removeVolunteer(volunteerId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    onToggleVolunteerStatus(volunteer) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'تأكيد تغيير الحالة',
        text: `هل أنت متأكد من تغيير حالة المتطوع "${volunteer.name}"؟`,
        acceptText: 'تأكيد',
        cancelText: 'إلغاء',
        accept: () => this.changeVolunteerStatus(volunteer),
        cancel: () => this.gridApi.refreshServerSideStore({ purge: true }),
      });
    },
    async changeVolunteerStatus(volunteer) {
      try {
        await volunteerRepo.toggleStatus(volunteer.id, { isActive: volunteer.isActive });
      } catch {
        // request failed; the httpClient interceptor already shows the error toast
      }
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onResetVolunteerPassword(volunteer) {
      const res = await volunteerRepo.resetVolunteerPassword(volunteer.id);
      if (res.status === 201 || res.status === 200) {
        this.$refs.volunteerPopup.close();
        await this.gridApi.refreshServerSideStore({ purge: true });
      }
    },
    onOpenUploadPopup() {
      this.volunteersImagesFile = null;
      this.uploadProgress = 0;
      this.uploadState = 'idle';
      this._clearPoll();
      this.$refs.uploadPopup.open();
    },
    async onUploadZipFile() {
      try {
        this.uploadProgress = 0;
        this.uploadState = 'uploading';

        const res = await volunteerRepo.uploadVolunteersImagesFile(
          this.volunteersImagesFile,
          (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          }
        );

        const jobId = res.data.jobId;
        this.uploadState = 'processing';
        this._pollJobStatus(jobId);
      } catch {
        this.uploadState = 'failed';
        this.$refs.uploadPopup.endLoading();
      }
    },
    _pollJobStatus(jobId) {
      this.pollInterval = setInterval(async () => {
        try {
          const { state } = await volunteerRepo.getUploadJobStatus(jobId);
          if (state === 'completed') {
            this._clearPoll();
            this.uploadState = 'completed';
            this.$refs.uploadPopup.endLoading();
            setTimeout(() => this.$refs.uploadPopup.close(), 1500);
          } else if (state === 'failed') {
            this._clearPoll();
            this.uploadState = 'failed';
            this.$refs.uploadPopup.endLoading();
          }
        } catch {
          this._clearPoll();
          this.uploadState = 'failed';
          this.$refs.uploadPopup.endLoading();
        }
      }, 3000);
    },
    _clearPoll() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },
    // onUpdateVolunteer(volunteer) {
    //   this.volunteerPopupTitle = 'تعديل معلومات المتطوع';
    //   this.resetVolunteerForm();
    //   Object.assign(this.volunteer, volunteer);
    //   this.$refs.volunteerPopup.open();
    // },
    // async onImportVolunteer(file) {
    //   await volunteerRepo.importVolunteers(file.rawFile);
    //   await this.gridApi.refreshServerSideStore({ purge: true });
    // },
    // onCreateVolunteer() {
    //   this.volunteerPopupTitle = 'إضافة متطوع جديد';
    //   this.resetVolunteerForm();
    //   this.$refs.volunteerPopup.open();
    // },
    // resetVolunteerForm() {
    //   Object.assign(this.volunteer, {
    //     name: null,
    //     phoneNumber: null,
    //     cardNumber: null,
    //     uniqueIdentifier: null,
    //   });
    // },
    // async onVolunteerPopupSubmit() {
    //   try {
    //     let res = null;
    //     if (this.volunteerPopupTitle == 'إضافة متطوع جديد') {
    //       res = await volunteerRepo.createVolunteer(this.volunteer);
    //     } else {
    //       res = await volunteerRepo.updateVolunteer(this.volunteer);
    //     }

    //     if (res.status === 201 || res.status === 200) {
    //       this.$refs.volunteerPopup.close();
    //       await this.gridApi.refreshServerSideStore({ purge: true });
    //     }
    //   } catch (err) {
    //     this.$refs.volunteerPopup.endLoading();
    //   }
    // },
    async getAllVolunteers(query) {
      return await volunteerRepo.fetchVolunteers(query);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
  beforeDestroy() {
    this._clearPoll();
  }
};
</script>

<style scoped>
button.export-tasksvolunteers,
button.upload-volunteers-zip {
  padding-inline: 8px;
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  appearance: none;
  color: white;
  border-radius: 7px;
  height: 40px;
  min-width: 120px;
  cursor: pointer;
  background: rgb(33, 158, 207);
  font-size: 14px;
  margin-left: 8px;
}

button.upload-volunteers-zip {
  background: rgb(115, 103, 240);
}

.upload-status {
  margin-top: 8px;
}

.upload-status__label {
  font-size: 13px;
  margin-bottom: 6px;
  color: #444;
}

.upload-status__label--processing { color: #e6a817; }
.upload-status__label--success    { color: #28a745; }
.upload-status__label--error      { color: #dc3545; }

.upload-status__bar-track {
  width: 100%;
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.upload-status__bar-fill {
  height: 100%;
  background: rgb(115, 103, 240);
  border-radius: 4px;
  transition: width 0.3s ease;
}
</style>
